<h2 class="sr-only">{{ "EgridSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="egrid" #form="ngForm">
  <cap-form-row>
    <cap-form-control column-classes="col-md-1,col-md-3" invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
      <input
        (ngModelChange)="egrid && (egrid.egrid.value = $event) && trim($event)"
        [ngModel]="egrid && egrid.egrid && egrid.egrid.value"
        #grundstueckEgridSuche
        appAutofocus
        id="egrid.egrid.value"
        name="egrid.egrid.value"
        required
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <div class="row">
    <div class="col-3 my-2">
      <cap-history-options
        (ngModelChange)="egrid && (egrid.historySearchOptions = $event)"
        [ngModel]="egrid && egrid.historySearchOptions"
        name="historySearchOptions"></cap-history-options>
    </div>
  </div>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset(grundstueckEgridSuche)" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
